import React, {useEffect, useRef, useState} from 'react';
import {FlowData, RegisterFunction, SELFCARE_REPORT_FLOW_TYPE} from "../../../../util/types.ts";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import {filterIllegalCharcters, scrollToElement} from "../../../../util/helpers.ts";

interface DescriptionTextFieldProps {
    flowData: FlowData;
    setFlowData: React.Dispatch<React.SetStateAction<FlowData>>;
    flowtype?: SELFCARE_REPORT_FLOW_TYPE;
    placeholder?: string;
    register: RegisterFunction;
}

export default function DescriptionTextFieldComponent({
        flowData,
        setFlowData,
        flowtype,
        placeholder = "Beskriv hvilke problemer du oplever",
        register,
    }: DescriptionTextFieldProps) {
    const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        let input = event.target.value;

        if (input.length > 500) {
            input = input.substring(0, 500);
        }

        if (input.length > 0) {
            setDescriptionError('')
        }

        const sanitizedInput = filterIllegalCharcters(input);
        setFlowData((prev) => ({ ...prev, descriptionText: sanitizedInput }));
    };
    const [descriptionError, setDescriptionError] = useState<string>('');

    const hasError = descriptionError.length > 0;

    const descriptionSectionComponentTop = useRef() as React.MutableRefObject<HTMLDivElement>;

    useEffect((): void => {
        register("DescriptionTextFieldComponent",
            {
                hasErrors: (flowData: FlowData): boolean => {

                    if (!flowData.descriptionText.trim()) {
                        setDescriptionError("Forklar hvilke problemer du oplever med dit internet.");
                        return true
                    }
                    return false
                },
                scrollToError: (): void => {
                    scrollToElement(descriptionSectionComponentTop.current)
                },
            },
        )
    }, [register, descriptionError]);

    return (
        <div className={`input-container${hasError ? ' error' : ''}`} ref={descriptionSectionComponentTop}>
            <ScrollToAnchorPoint id={'description-section'} className={'id-anchor--selfcare-report-error'}/>
            <p>
                {flowtype === SELFCARE_REPORT_FLOW_TYPE.SPEED && (
                    'Notér resultatet fra din hastighedstest, og om du lavede testen på wifi eller et netværkskabel'
                )}
                {flowtype === SELFCARE_REPORT_FLOW_TYPE.UNSTABLE && (
                    'Beskriv hvilke problemer du oplever med dit internet samt om det sker i specifikke tidsrum*'
                )}
                {flowtype !== SELFCARE_REPORT_FLOW_TYPE.SPEED && flowtype !== SELFCARE_REPORT_FLOW_TYPE.UNSTABLE && (
                    'Beskriv hvad du oplever med dit internet*'
                )}
            </p>
            <textarea
                id={'descriptionText'}
                name={'descriptionText'}
                value={flowData.descriptionText}
                onChange={handleInputChange}
                placeholder={placeholder}
                rows={4}
            />
            {flowtype === 'SPEED' && (
                <p className={'small'}>
                    Vedhæft gerne et skærmbillede af din hastigheds&shy;test længere nede på siden.
                </p>
            )}
            {hasError && <p className={'error-message'}>{descriptionError}</p>}
        </div>
    );
}
